export default __webpack_public_path__ + "static/Artboard-e51ae980230507345740c7418740561a.svg";